import Axios from "axios";
import { useEffect, useState } from "react";
import { Box, IconButton } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button } from "@mui/material";
import { MenuItem } from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";

const Services = () => {

  const [data, setData] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const [editService, setEditService] = useState(null);

  const [newService, setNewService] = useState({
    service_name: "",
    customer_id: "",
    amount: "",
    paid_amount: "",
    balance: "",
    due_date: "",
    service_date: ""
  });

  // Fetch services + customers
  useEffect(() => {

    const fetchData = async () => {
      try {

        const services = await Axios.get("https://store.petplanet.rw/api/services");
        const customers = await Axios.get("https://store.petplanet.rw/api/customers");

        setData(services.data || []);
        setCustomers(customers.data || []);

      } catch (error) {
        console.error("Fetch error", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();

  }, []);

  const refreshData = async () => {

    const res = await Axios.get("https://store.petplanet.rw/api/services");
    setData(res.data || []);

  };

  // Calculate balance
  const calculateBalance = (amount, paid) => {

    const balance = parseFloat(amount || 0) - parseFloat(paid || 0);

    return balance > 0 ? balance : 0;

  };

  // Add Service
  const handleAddService = async () => {
  
    const balance = calculateBalance(newService.amount, newService.paid_amount);
  
    const payload = {
      ...newService,
      balance: balance,
      due_date: balance > 0 ? newService.due_date : null
    };
  
    try {
  
      await Axios.post("https://store.petplanet.rw/api/services", payload);
  
      alert("Service added successfully");
  
      setIsAddModalOpen(false);
  
      refreshData();
  
    } catch (error) {
      console.error(error);
    }
  
  };
  const handleUpdateService = async () => {
  
  try{
  
  const balance =
  parseFloat(editService.amount || 0) -
  parseFloat(editService.paid_amount || 0);
  
  await Axios.put(
  `https://store.petplanet.rw/api/services/${editService.id}`,
  {
  ...editService,
  balance: balance > 0 ? balance : 0,
  due_date: balance > 0 ? editService.due_date : null
  }
  );
  
  alert("Service updated successfully");
  
  setIsEditModalOpen(false);
  
  refreshData();
  
  }catch(error){
  console.error(error);
  }
  
  };
  const handleDelete = async (id) => {

    if (!window.confirm("Delete this service?")) return;

    await Axios.delete(`https://store.petplanet.rw/api/services/${id}`);

    refreshData();

  };

  const columns = [

    {
      field: "service_name",
      headerName: "Service",
      flex: 1
    },

    {
      field: "customer",
      headerName: "Customer",
      flex: 1,
      renderCell: (params) => params.row.customer?.name || "-"
    },

    {
      field: "amount",
      headerName: "Amount",
      flex: 1,
      renderCell: (params) =>
        `${parseFloat(params.value || 0).toLocaleString()} RWF`
    },

    {
      field: "paid_amount",
      headerName: "Paid",
      flex: 1,
      renderCell: (params) =>
        `${parseFloat(params.value || 0).toLocaleString()} RWF`
    },

    {
      field: "balance",
      headerName: "Balance",
      flex: 1,
      renderCell: (params) =>
        `${parseFloat(params.value || 0).toLocaleString()} RWF`
    },

    {
      field: "due_date",
      headerName: "Due Date",
      flex: 1
    },

    {
      field: "actions",
      headerName: "Actions",
      renderCell: (params) => (

        <Box>

          <IconButton
            color="secondary"
            onClick={() => {
              setEditService(params.row);
              setIsEditModalOpen(true);
            }}
          >
            <EditOutlinedIcon />
          </IconButton>

          <IconButton
            style={{ color: "#FF0000" }}
            onClick={() => handleDelete(params.row.id)}
          >
            <DeleteOutlinedIcon />
          </IconButton>

        </Box>
      )
    }

  ];

  return (
    <>
      <Box m="20px" mt="80px">

        <Box display="flex" justifyContent="space-between" alignItems="center">

          <Header title="Services" subtitle="Manage services and payments" />

          <IconButton
            onClick={() => setIsAddModalOpen(true)}
            sx={{
               fontSize: "13px",
               backgroundColor: tokens.redAccent[400],
               border: "none",
               color: tokens.grey[100],
               padding: "14px",
               borderRadius: "10px",
               display: "flex",
               alignItems: "center",
               justifyContent: "center",
               gap: "5px",
               marginTop: "-13px",
               transition: "all 0.3s ease",
               "&:hover": {
                 outline: `2px solid ${tokens.redAccent[400]}`,
                 outlineOffset: "1px",
                 backgroundColor: tokens.redAccent[200],
               },
               "&:active": {
                 outline: `2px solid ${tokens.redAccent[500]}`,
                 transform: "scale(0.97)",
               },
            }}
          >
            Add Service <AddOutlinedIcon fontSize="15px" />
          </IconButton>

        </Box>

        <Box m="20px 0 0 0" height="75vh"
          sx={{
              "& .MuiDataGrid-root": {
                border: "none",
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "none",
              },
              "& .name-column--cell": {
                color: tokens.grey[800],
              },
              "& .MuiDataGrid-virtualScroller": {
                backgroundColor: tokens.grey[100],
              },
              "& .MuiCheckbox-root": {
                border: "none",
                color: `${tokens.redAccent[400]} !important`,
              },
              "& .MuiDataGrid-columnHeader.action-column--header": {
                background: "none",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                color: `${tokens.grey[900]} !important`,
                fontSize: "12px",
              },
              "& .MuiDataGrid-columnSeparator--resizable": {
                color: `${tokens.blueAccent[100]} !important`,
              }
            }}
        >

          <DataGrid
            checkboxSelection
            rows={data}
            columns={columns}
            loading={loading}
            slots={{ toolbar: GridToolbar }}
          />

        </Box>

      </Box>

      {/* ADD SERVICE MODAL */}

      <Dialog 
        sx={{
              "& .MuiDialog-paper": {
                width:"600px",
              }
            }}
        open={isAddModalOpen} onClose={() => setIsAddModalOpen(false)}>

        <DialogTitle fontSize="20px" backgroundColor={tokens.redAccent[200]} color={tokens.blueAccent[400]}>Add Service</DialogTitle>

        <DialogContent>

          <TextField
            label="Service Name"
            fullWidth
            margin="normal"
            value={newService.service_name}
            onChange={(e) =>
              setNewService({ ...newService, service_name: e.target.value })
            }
          />
          <Box display="flex" gap="10px">
          <TextField
            select
            label="Customer"
            fullWidth
            margin="normal"
            value={newService.customer_id}
            onChange={(e) =>
              setNewService({ ...newService, customer_id: e.target.value })
            }
          >
            {customers.map((customer) => (
              <MenuItem key={customer.id} value={customer.id}>
                {customer.name}
              </MenuItem>
            ))}
          </TextField>
  
          <TextField
            label="Amount"
            type="number"
            fullWidth
            margin="normal"
            value={newService.amount}
            onChange={(e) =>
              setNewService({ ...newService, amount: e.target.value })
            }
          />
          </Box>
         <Box display="flex" gap="10px">
          <TextField
            label="Paid Amount"
            type="number"
            fullWidth
            margin="normal"
            value={newService.paid_amount}
            onChange={(e) =>
              setNewService({ ...newService, paid_amount: e.target.value })
            }
          />

          <TextField
            label="Service Date"
            type="date"
            fullWidth
            margin="normal"
            InputLabelProps={{ shrink: true }}
            value={newService.service_date}
            onChange={(e) =>
              setNewService({ ...newService, service_date: e.target.value })
            }
          />
          </Box>
          {calculateBalance(newService.amount, newService.paid_amount) > 0 && (
          <TextField
            label="Due Date"
            type="date"
            fullWidth
            margin="normal"
            InputLabelProps={{ shrink: true }}
            value={newService.due_date}
            onChange={(e) =>
              setNewService({ ...newService, due_date: e.target.value })
            }
          />
          )}
                    
        </DialogContent>

        <DialogActions style={{background:tokens.redAccent[200]}}>
          <Button onClick={() => setIsAddModalOpen(false)}>Cancel</Button>
          <Button onClick={handleAddService}>Save</Button>
        </DialogActions>

      </Dialog>

      {/* EDIT SERVICE MODAL */}
      <Dialog sx={{
        "& .MuiDialog-paper": {
          width:"800px",
          position:"absolute",
          top:"0",
          left:"60%",
          transform:"translateX(-50%)"
        }
      }} open={isEditModalOpen} onClose={() => setIsEditModalOpen(false)}>
      
      <DialogTitle style={{
        background: tokens.redAccent[100],
        color: tokens.blueAccent[300],
        fontSize:"17px"
      }}>
      Edit Service
      </DialogTitle>
      
      <DialogContent style={{ background: tokens.grey[100], padding:"20px 10px"}}>
      
      <Box style={{display:"flex", justifyContent:"space-between", gap:"20px"}}>
      
      <TextField
      label="Service Name"
      fullWidth
      value={editService?.service_name || ""}
      onChange={(e)=>
      setEditService({...editService, service_name:e.target.value})
      }
      />
      
      <TextField
      select
      label="Customer"
      fullWidth
      value={editService?.customer_id || ""}
      onChange={(e)=>
      setEditService({...editService, customer_id:e.target.value})
      }
      >
      {customers.map((customer)=>(
      <MenuItem key={customer.id} value={customer.id}>
      {customer.name}
      </MenuItem>
      ))}
      </TextField>
      
      </Box>
      
      <Box style={{display:"flex", justifyContent:"space-between", marginTop:"10px", gap:"20px"}}>
      
      <TextField
      label="Amount"
      type="number"
      fullWidth
      value={editService?.amount || ""}
      onChange={(e)=>
      setEditService({...editService, amount:e.target.value})
      }
      />
      
      <TextField
      label="Paid Amount"
      type="number"
      fullWidth
      value={editService?.paid_amount || ""}
      onChange={(e)=>
      setEditService({...editService, paid_amount:e.target.value})
      }
      />
      
      <TextField
      label="Service Date"
      type="date"
      fullWidth
      InputLabelProps={{ shrink:true }}
      value={editService?.service_date || ""}
      onChange={(e)=>
      setEditService({...editService, service_date:e.target.value})
      }
      />
      
      </Box>
      
      <Box style={{display:"flex", justifyContent:"space-between", marginTop:"10px", gap:"20px"}}>
      
      <TextField
      label="Due Date"
      type="date"
      fullWidth
      InputLabelProps={{ shrink:true }}
      value={editService?.due_date || ""}
      onChange={(e)=>
      setEditService({...editService, due_date:e.target.value})
      }
      />
      
      </Box>
      
      </DialogContent>
      
      <DialogActions style={{background:tokens.redAccent[200]}}>
      
      <Button
      style={{color:tokens.blueAccent[400]}}
      onClick={()=>setIsEditModalOpen(false)}
      >
      Cancel
      </Button>
      
      <Button
      style={{color:tokens.blueAccent[400]}}
      onClick={handleUpdateService}
      >
      Save
      </Button>
      
      </DialogActions>
      
      </Dialog>

    </>
  );
};

export default Services;